// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2FbiE","topBottomGutter":"Layout_topBottomGutter__rfhry"};